import { configureStore } from '@reduxjs/toolkit'
import authSlice from './auth'
import catalogSlice from './catalog'
import uiSlice from './ui'

const store = configureStore({
  reducer: {
    auth: authSlice,
    ui: uiSlice,
    catalog: catalogSlice
  }
})

export default store
